import { useParams, Link, Navigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { blogPosts } from "@/utils/blogData";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find(p => p.slug === slug);

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <div className="min-h-screen bg-[#f1f1f1] flex flex-col">
      <Seo
        title={post.title}
        description={post.excerpt}
        path={`/blog/${post.slug}`}
        type="article"
        image={post.image ? `https://cardcombiner.com${post.image}` : undefined}
        author={post.author}
        publishedDate={new Date(post.date).toISOString()}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Article",
          headline: post.title,
          description: post.excerpt,
          image: post.image ? `https://cardcombiner.com${post.image}` : undefined,
          author: { "@type": "Person", name: post.author },
          datePublished: new Date(post.date).toISOString(),
          mainEntityOfPage: `https://cardcombiner.com/blog/${post.slug}`,
          publisher: {
            "@type": "Organization",
            name: "CardCombiner",
            url: "https://cardcombiner.com",
          },
        }}
      />
      <Navbar />
      <main className="mx-auto w-full min-w-0 max-w-4xl flex-grow overflow-hidden p-4 md:p-8">
        <div className="mb-6">
          <Button variant="ghost" asChild className="text-[#6B4EE6] hover:text-[#5a3fd4]">
            <Link to="/blog" className="flex items-center gap-2">
              <ArrowLeft className="w-4 h-4" />
              Back to Blog
            </Link>
          </Button>
        </div>
        
        <Card className="min-w-0 overflow-hidden bg-white rounded-[16px] md:rounded-[24px] shadow-lg">
          <CardHeader className="min-w-0 pb-4">
            <div className="mb-4 min-w-0">
              <h1 className="break-words text-2xl font-bold leading-tight text-[#6B4EE6] md:text-4xl">
                {post.title}
              </h1>
            </div>
            <div className="flex flex-wrap items-center justify-between gap-2 text-sm text-gray-600">
              <span className="italic">By {post.author}</span>
              <span>{post.date}</span>
            </div>
          </CardHeader>
          <CardContent className="prose prose-sm max-w-none min-w-0 overflow-hidden pt-4 md:prose-base">
            {post.content}
          </CardContent>
        </Card>
      </main>
      <Footer />
    </div>
  );
};

export default BlogPost;